import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/modules/shared.module';
import { ReleaseCardComponent } from './release-card/release-card.component';

@NgModule({
  declarations: [ReleaseCardComponent],
  imports: [CommonModule, SharedModule],
  exports: [ReleaseCardComponent],
})
export class ReleaseModule {}
